import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // added by angular material
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';
import { AuthInterceptor } from 'src/app/_helpers/auth.interceptor';
import { AppRoutingModule } from './app-routing.module';
import { environment } from 'src/environments/environment';
import { initializeApp } from 'firebase/app';
initializeApp(environment.firebase);
import { AppComponent } from './app.component';
import { ContentAnimateDirective } from './shared/directives/content-animate.directive';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { FooterComponent } from './shared/footer/footer.component';
import { SpinnerComponent } from './shared/spinner/spinner.component';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { NotificationsComponent } from './shared/notifications/notifications.component';
import { FileUploadModule } from 'ng2-file-upload';
import { NgImageSliderModule } from 'ng-image-slider';
import { MatDialogModule } from '@angular/material/dialog';
import { ReasonDeclinedComponent } from './shared/reason-declined/reason-declined.component';
import { SendNotificationComponent } from './shared/send-notification/send-notification.component';
import { ChatCustomerListingComponent } from './shared/chat-customer-listing/chat-customer-listing.component';
import { NotificationAlertComponent } from './shared/notification-alert/notification-alert.component';
import { ImageCropperModule } from 'ngx-image-cropper';

@NgModule({
  declarations: [
    AppComponent,
    ContentAnimateDirective,
    NavbarComponent,
    SidebarComponent,
    FooterComponent,
    SpinnerComponent,
    LoginComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    NotificationsComponent,
    ReasonDeclinedComponent,
    SendNotificationComponent,
    ChatCustomerListingComponent,
    NotificationAlertComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    LoadingBarHttpClientModule,
    SweetAlert2Module,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireStorageModule,
    FileUploadModule,
    NgImageSliderModule,
    MatDialogModule,
    ImageCropperModule
  ],
  providers: [
    DeviceDetectorService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
